import { useState, useEffect, useContext } from "react";
import {
	Request,
	catchErrorHandle,
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	sysMsg,
	setOnProcessGame,
	getOnProcessGame,
	playGame,
	exitGame,
} from "../common";
import Modal from "../components/Modal";

let isOnProcess = false;

export default function App() {
	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);
	const [onProcessGameRes, setOnProcessGameRes] = useState({});

	useEffect(() => {
		const getData = async () => {
			try {
				const res = await getOnProcessGame();
				setOnProcessGameRes(res);
			} catch (error) {}
		};

		getData();
	}, [_state.reGetOnProcessGame]);

	const startGame = async (orderInfo) => {
		try {
			const { order_out_sn, product_name, game_id, platform } = orderInfo;

			const playParam = [
				order_out_sn,
				product_name,
				0,
				3,
				0,
				game_id,
				platform + 1,
			];

			_dispatch(creator("setGlobalMsg", ""));

			playGame(playParam);

			_dispatch(creator("setStartStepIsShow", true));
		} catch (error) {
			_dispatch(creator("setGlobalMsg", ""));

			sysMsg({
				msg: "上号失败，请重试",
			});
		}
	};

	const stopGame = () => {
		exitGame();
	};

	const getGameId = (orderInfo) => {
		return new Promise(async (resolve, reject) => {
			try {
				const req = new Request({
					url: "/api/getProductDetail",
					data: {
						product_id: orderInfo.productId,
					},
				});

				const res = await req.send();

				if (res.status_code === 1000) {
					const { game_id, product_name, platform } = res.data;
					const data = {
						...orderInfo,
						game_id,
						product_name,
						platform,
					};

					setOnProcessGame({
						orderInfo: data,
					});

					resolve(data);
				} else {
					throw new Error(res.message || "获取游戏详情出错，请联系客服");
				}
			} catch (error) {
				reject(catchErrorHandle(error));
			}
		});
	};

	const xuBeiOrderInfo = (orderInfo) => {
		return new Promise(async (resolve, reject) => {
			try {
				const req = new Request({
					url: `/api/open/business/query/${orderInfo.orderSn}`,
				});

				const res = await req.send();

				if (res.status_code === 1000 && res.data?.account) {
					const { order_no: order_out_sn } = res.data.account;
					const data = {
						...orderInfo,
						order_out_sn,
					};

					setOnProcessGame({
						orderInfo: data,
					});

					resolve(data);
				} else {
					throw new Error(res.message || "启动游戏失败，请联系客服");
				}
			} catch (error) {
				reject(catchErrorHandle(error));
			}
		});
	};

	const orderAndStart = async (orderInfo) => {
		try {
			startGame(await xuBeiOrderInfo(orderInfo));
		} catch (error) {
			sysMsg({
				msg: catchErrorHandle(error),
			});
		}
	};

	const readyStart = async (data) => {
		try {
			if (isOnProcess) return;

			const { isOnline } = await getOnProcessGame();

			if (isOnline) {
				Modal.tips({
					icon: "warning",
					contentHead: "当前正在游戏中",
					contentBody: "切换游戏会导致当前游戏退出",
					onOk: async (c) => {
						try {
							c();
							await stopGame();

							readyStart(data);
						} catch (error) {
							sysMsg({
								msg: "停止游戏失败",
							});
						}
					},
					okText: "确定",
					onCancel: (c) => {
						c();
					},
					cancelText: "取消",
				});
			} else {
				//防抖
				isOnProcess = true;
				_dispatch(creator("setGlobalMsg", "请稍后，正在获取游戏详情"));
				setTimeout(() => {
					isOnProcess = false;
				}, 3000);

				setOnProcessGame({
					orderInfo: data,
				});

				const orderInfo = await getGameId(data);
				const {
					remainMinutes = 0,
					game_id,
					isMemberPlay,
					isNetbarPlay,
				} = orderInfo;
				if (remainMinutes > 0 && !isMemberPlay && !isNetbarPlay) {
					//非大会员和网吧上号且订单有剩余时间，直接用内部订单号
					orderAndStart(orderInfo);
				} else {
					//订单无剩余时间用内部订单号重新发起合玩流程
					//大会员和网吧上号需要获取内部订单再走发起合玩流程
					const req = new Request({
						url: "/api/user/v1/game_remain_time",
						source: 2,
						headers: {
							token: _state.token,
						},
						data: {
							game_id,
						},
					});

					const res = await req.send();

					if (res.base.code === "200" && res.data?.data) {
						const data = JSON.parse(res.data.data);
						const { times = [] } = data;

						const useAble = [];
						for (let index = 0; index < times.length; index++) {
							const element = times[index];
							if (element.able) {
								useAble.push(`${element.time}小时`);
							}
						}

						if (useAble.length) {
							_dispatch(creator("setGlobalMsg", ""));
							_dispatch(
								creator("setSelectTimeIsShow", {
									isShow: true,
									useAble,
									playType: isMemberPlay
										? "memberPlay"
										: isNetbarPlay
										? "netbarPlay"
										: "normalPlay",
								})
							);
						} else {
							throw new Error("当前暂不可进行游戏");
						}
					} else {
						throw new Error("当前暂不可进行游戏");
					}
				}
			}
		} catch (error) {
			_dispatch(creator("setGlobalMsg", ""));

			sysMsg({
				msg: catchErrorHandle(error),
			});
		}
	};

	return {
		readyStart,
		orderAndStart,
		stopGame,
		onProcessGame: onProcessGameRes, //开始上号、上号过程中、上号成功和退出游戏才会更新
	};
}
